import AxiosConfig from '../config/axiosConfigApiPlataform'

export const PlataformHeaderApi = {

  async toggleDarkMode () {
    let response = await AxiosConfig.api().post('modonoturno')
    return response.data
  }
}

export default PlataformHeaderApi
